import { Box, BoxProps } from '@mui/material';

import { mergeSx } from '../../../../utils';
import { useTableContext } from '../../hooks';

type Props = BoxProps & {
  column?: string;
  startColumn?: string | number;
  endColumn?: string | number;
  cellProps?: BoxProps;
};

export const ExternalCell = ({
  startColumn,
  endColumn,
  children,
  cellProps,
  sx,
  ...props
}: Props) => {
  const { api } = useTableContext()!;
  const columnModels = api.current.columnsInfo.columnModels;
  if (!startColumn) {
    startColumn = 0;
  }
  if (!endColumn) {
    endColumn = startColumn;
  }
  let startOffset: number | undefined;
  let width = 0;
  let startColumnIndex: number | undefined;
  if (typeof startColumn === 'string') {
    for (let i = 0; i < columnModels.length; i++) {
      const column = columnModels[i];
      if (column.id !== startColumn) {
        continue;
      }
      startOffset = column.startOffset;
      width = column.computedWidth;
      startColumnIndex = i;
      break;
    }
  } else {
    const column = columnModels[startColumn];
    startOffset = column.startOffset;
    width = column.computedWidth;
    startColumnIndex = startColumn;
  }

  if (startColumnIndex === undefined) {
    return null;
  }

  if (endColumn) {
    for (let i = startColumnIndex; i < columnModels.length; i++) {
      const column = columnModels[i];
      if (
        (typeof endColumn === 'string' && column.id === endColumn) ||
        (typeof endColumn === 'number' && i === endColumn)
      ) {
        break;
      }
      width += column.computedWidth;
    }
  }

  return (
    <Box
      className="DS-Table-CellWrapper"
      sx={mergeSx(
        {
          '&.DS-Table-CellWrapper': {
            position: 'absolute',
            pl: !startColumnIndex ? 'inherit' : undefined,
            typography: 'inherit',
            width,
            left: startOffset,
          },
        },
        sx
      )}
      {...props}
    >
      <Box className="DS-Table-Cell" typography="inherit" {...cellProps}>
        {children}
      </Box>
    </Box>
  );
};
